/* eslint-disable */
(function() {
	var jsCarousel = function(options) {
		options = options || {};
		var $carousel = $(this),
			$carouselContainer = $carousel.find(".js-carousel__container"),
			$prev = $carousel.find(".js-carousel__prev"),
			$next = $carousel.find(".js-carousel__next"),
			params = {
				blockWidth: 0,
				leftPosition: 0,
				containerWidth: 0,
				slideCount: $carousel.find(".js-carousel-slide").length || 0,
				slideWidth:0,
				moveCount: 0
			};
		$next.on("click", function (e) {
			e.preventDefault();
			e.stopPropagation();
			updateParams();
			nextSlide();
		});
		$prev.on("click", function (e) {
			e.preventDefault();
			e.stopPropagation();
			updateParams();
			prevSlide();
		});
		$(window).on("resize", function () {
			$carouselContainer.css({
				left: 0
			});
			params.moveCount = 0;
			updateParams();
		}).trigger("resize");

		if(options){
			if(options.moveToSlide){
				updateParams();
				for(var i = 1; i<= options.moveToSlide; i++){
					//nextSlide();
				}
			}
		}

		function nextSlide() {
			params.moveCount++;
			var left = params.moveCount * params.slideWidth;
			if(left > params.containerWidth){
				params.leftPosition = params.containerWidth;
				params.moveCount--;
			}else{
				params.leftPosition = left
			}
			$carouselContainer.css({
				left: -params.leftPosition
			})
		}
		function prevSlide() {
			params.moveCount--;
			var left = params.moveCount * params.slideWidth;
			if(left >= 0){
				params.leftPosition = left
			}else{
				params.leftPosition = 0;
				params.moveCount++;
			}
			$carouselContainer.css({
				left: -params.leftPosition
			})
		}

		function updateParams() {
			params.blockWidth = $carousel.width();
			params.slideWidth = $carousel.find(".js-carousel-slide:last").outerWidth(true);
			params.containerWidth = 0;
			$carouselContainer.find(".js-carousel-slide").each(function () {
				params.containerWidth += $(this).outerWidth(true)
			});

			if(params.blockWidth >= params.containerWidth){
				$prev.hide();
				$next.hide();
				$carouselContainer.addClass('center');
			}else{
				$prev.show();
				$next.show();
				$carouselContainer.removeClass('center');
			}
			params.containerWidth -= params.blockWidth - 1;
		}
	};

	$.fn.jsCarousel = jsCarousel
}());